<script setup lang="ts">
const props = defineProps<{
  modelValue: string | null;
  dense?: boolean;
}>();

const emits = defineEmits<{
  "update:modelValue": [val: string];
}>();
</script>

<template>
  <IconField iconPosition="left">
    <InputIcon class="pi pi-search"> </InputIcon>
    <InputText
      :model-value="modelValue"
      placeholder="Search..."
      @update:model-value="emits('update:modelValue', $event)"
    />
  </IconField>
</template>
